import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "wrapper" };
import Greeting from './components/Greeting.vue';
import Trigger from './components/Trigger.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("header", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(Greeting, { msg: "Http Logs to Seq" })
                    ])
                ]),
                _createElementVNode("main", null, [
                    _createVNode(Trigger)
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
